module.exports = __webpack_public_path__ + "img/blue_star.40772935.png";